export default __webpack_public_path__ + "static/media/cowboy-animations.15c63deb.gif";